import Swiper, { Grid, Navigation, Pagination, Thumbs} from 'swiper';
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
Swiper.use([Navigation, Pagination, Thumbs, Grid]);

export const swiper = ()=>{

    //MODAL PRINCIPAL
    const swiperSliderModal = new Swiper(".swiperSliderModal", {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        pagination: {
          el: ".swiperSliderModal .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            let labels = ['Contexto', 'Videos', 'Pódcast', 'Fotografía', 'Infografía'];
            return '<div class="changetab ' + className + '">' + (labels[index]) + '</div>';
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
    });
    var swiperSliderGalleryMini = new Swiper(".swiperSliderGalleryMini", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          direction: 'horizontal',
          slidesPerView: 3
        },
        993: {
          direction: 'vertical',
          slidesPerView: 3
        }
      }
    });
    var swiperSliderGallery = new Swiper(".swiperSliderGallery", {
      spaceBetween: 10,
      allowTouchMove: false,
      pagination: {
        el: '.swiper-gallery .swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      //effect: "fade",
      thumbs: {
        swiper: swiperSliderGalleryMini,
      },
    });

    return{
      swiperSliderModal
    }
}
